import React from "react";

import {cn} from "@/utils/utils.ts";
import {siteConfig} from "@/config/site.ts";

export const SiteNameMultiRow = ({className}: { className?: string }) => {
    return (
        <div className="flex flex-col">
            <div
                className={cn("text-md font-bold", className)}
                style={{color: "rgba(235, 235, 245, 0.7)", letterSpacing: "-0.03em", lineHeight: "0.95"}}
            >
                {'VIDEO'}
            </div>
            <div
                className={cn("text-md font-bold text-white", className)}
                style={{letterSpacing: "-0.03em", lineHeight: "0.95"}}
            >
                {'HIGHLIGHT'}
            </div>

        </div>
    )
};